import { render, staticRenderFns } from "./QSubmenu.vue?vue&type=template&id=e9465bd2&"
import script from "./QSubmenu.vue?vue&type=script&lang=js&"
export * from "./QSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports